/**
 * O vínculo existe, o portal ainda não (A007). Diz onde ele vive hoje e
 * oferece trocar de vínculo ou sair. Some sozinha quando o portal chega.
 */
import { Button, Stack, Text } from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons-react';
import { Navigate, useNavigate } from 'react-router-dom';
import { portalFor, ROLE_LABELS, useSession, useBrand } from '@eva/domain';
import { caminhoDeSaida } from '../app/sair';
import { AuthFrame } from './AuthFrame';

export function LegacyHandoffPage() {
  const { brand } = useBrand();
  const session = useSession();
  const navigate = useNavigate();

  if (session.status === 'choosing') return <Navigate to="/contextos" replace />;
  if (session.status !== 'ready' || !session.context) return null;

  const portal = portalFor(session.context.role);
  if (portal.available) return <Navigate to={portal.path} replace />;

  const papel = ROLE_LABELS[session.context.role];
  const ehPaciente = portal.id === 'eu';

  return (
    <AuthFrame
      title={ehPaciente ? 'Seu app continua no endereço de sempre' : 'Este acesso ainda está no painel atual'}
      subtitle={`Você entrou como ${papel.toLowerCase()}. Estamos trazendo essa área para cá aos poucos.`}
    >
      <Stack gap="sm">
        {portal.legacyUrl && (
          <Button component="a" href={portal.legacyUrl} size="md" rightSection={<IconArrowUpRight size={18} />} fullWidth>
            {ehPaciente ? 'Abrir o app' : 'Abrir o painel'}
          </Button>
        )}
        {session.contexts.length > 1 || true ? (
          <Button variant="light" onClick={() => session.reopenChooser().then(() => navigate('/contextos'))} fullWidth>
            Entrar de outro jeito
          </Button>
        ) : null}
        <Button variant="subtle" color="gray" onClick={() => session.logout().then(() => navigate(caminhoDeSaida(brand.slug), { replace: true }))} fullWidth>
          Sair
        </Button>
        <Text fz="xs" c="dimmed" ta="center">
          Você vai precisar entrar de novo lá — por enquanto os dois vivem separados.
        </Text>
      </Stack>
    </AuthFrame>
  );
}
